import React from 'react'
import { Form } from 'semantic-ui-react'

export default class BranchesField extends React.PureComponent {
  render() {
    const { onChange, value, allBranches } = this.props

    return (
      <Form.Select
        fluid
        required
        options={allBranches}
        label="Branches"
        placeholder="Please choose branch"
        onChange={(e, data) => onChange(data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/deliveryFeeOffer/fields/branchesField.js